import $ from 'jquery';
import './core.js';
import 'slick-carousel';
import Swiper from 'swiper';
import { Pagination, FreeMode, Thumbs, Navigation } from 'swiper/modules';
import { apiFetch } from './core.js';

$(document).ready(function () {

    $('[data-product-count]').productCounter();

});

/**
 * ============================================================================
 * COMPATIBILITY
 * ============================================================================
 */

class ProductGallery {
	constructor(wrapperSelector) {
		this.wrapper = document.querySelector(wrapperSelector);

		if (!this.wrapper) return;

		this.thumbsNode = this.wrapper.querySelector('[data-product-gallery-thumbs]');
		this.mainNode = this.wrapper.querySelector('[data-product-gallery-main]');
		this.nextBtn = this.wrapper.querySelector('.product-gallery__arrow-next');
		this.prevBtn = this.wrapper.querySelector('.product-gallery__arrow-prev');
		this.paginationNode = this.wrapper.querySelector('.product-gallery__pagination');

		this.thumbsSlider = null;
		this.mainSlider = null;

		this.init();
	}

	init() {
		if (!this.thumbsNode || !this.mainNode) return;

		this.initThumbsSlider();
		this.initMainSlider();
	}

	initThumbsSlider() {
		this.thumbsSlider = new Swiper(this.thumbsNode, {
			modules: [FreeMode],
			direction: 'vertical',
			slidesPerView: 4,
			autoHeight: false,
			spaceBetween: 16,
			freeMode: true,
			watchSlidesProgress: true,
		});
	}

	initMainSlider() {
		this.mainSlider = new Swiper(this.mainNode, {
			modules: [Navigation, Pagination, Thumbs],
			spaceBetween: 0,
			navigation: {
				nextEl: this.nextBtn,
				prevEl: this.prevBtn,
			},
			pagination: {
				el: this.paginationNode,
				clickable: true,
			},
			thumbs: {
				swiper: this.thumbsSlider,
			},
		});
	}
}

class CarCompatibility {
	constructor() {
		this.selectors = {
			container: '[data-car-compatibility]',
			header: '[data-car-compatibility__model-name]',
			accordion: '[data-car-compatibility__model-accordion]'
		};

		this.init();
	}

	init() {
		document.addEventListener('click', (e) => {
			const header = e.target.closest(this.selectors.header);
			if (header) {
				this.handleToggle(header);
			}
		});
	}

	async handleToggle(header) {
		const accordion = header.nextElementSibling;
		const container = header.closest(this.selectors.container);
		const urlSpan = header.querySelector('span[data-url]');
		const url = urlSpan ? urlSpan.dataset.url : null;

		if (!accordion || !accordion.matches(this.selectors.accordion)) return;

		const isExpanded = header.getAttribute('aria-expanded') === 'true';

		if (accordion.children.length === 0 && url && !isExpanded) {
			await this.loadData(url, accordion, container, header);
		} else {
			this.toggleAccordion(header, accordion, !isExpanded);
		}
	}

	async loadData(url, accordion, container, header) {
		if (container) container.classList.add('block-loader');

		try {
			const response = await apiFetch(url, {
				method: 'POST',
			});

			if (!response.ok) throw new Error('Network response was not ok');

			const data = await response.json();
			accordion.innerHTML = data.html;
		} catch (error) {
			console.warn('Error loading car compatibility data', error);
		} finally {
			if (container) container.classList.remove('block-loader');
			this.toggleAccordion(header, accordion, true);
		}
	}

	toggleAccordion(header, accordion, forceOpen) {
		if (forceOpen) {
			header.classList.add('open');
			header.setAttribute('aria-expanded', 'true');
			accordion.classList.add('is-visible');
			accordion.hidden = false;
		} else {
			header.classList.remove('open');
			header.setAttribute('aria-expanded', 'false');
			accordion.classList.remove('is-visible');
			accordion.hidden = true;
		}
	}
}

class ProductCardSlider {
	/**
	 * @param {HTMLElement} element - DOM-узел обертки слайдера
	 */
	constructor(element) {
		this.sliderElement = element;
		this.swiperInstance = null;
		this.paginationElement = this.sliderElement.querySelector('.swiper-pagination');

		this.init();
	}

	init() {
		if (this.sliderElement.classList.contains('swiper-initialized')) {
			return;
		}

		this.swiperInstance = new Swiper(this.sliderElement, {
			modules: [Pagination],
			slidesPerView: 1,
			spaceBetween: 0,
			loop: false,
			nested: true,
			observer: true,
			observeParents: true,
			watchOverflow: true,

			pagination: {
				el: this.paginationElement,
				clickable: true,
			},

			grabCursor: true,
		});
	}

	destroy() {
		if (this.swiperInstance) {
			this.swiperInstance.destroy(true, true);
			this.swiperInstance = null;
		}
	}
}

class PopularProductsSlider {
	constructor(element) {
		this.sliderElement = element;
		this.sectionWrapper = this.sliderElement.closest('.popular-products');

		this.btnNext = this.sectionWrapper.querySelector('.popular-products__btn-next');
		this.btnPrev = this.sectionWrapper.querySelector('.popular-products__btn-prev');

		this.swiperInstance = null;
		this.init();
	}

	init() {
		if (this.sliderElement.classList.contains('swiper-initialized')) {
			return;
		}

		this.swiperInstance = new Swiper(this.sliderElement, {
			modules: [Navigation],
			slidesPerView: 1,
			spaceBetween: 16,
			watchOverflow: true,

			navigation: {
				nextEl: this.btnNext,
				prevEl: this.btnPrev,
			},

			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 24,
				},
				1280: {
					slidesPerView: 4,
					spaceBetween: 24,
				}
			}
		});
	}
}

export class SidebarAccordion {
	constructor(containerSelector, titleSelector) {
		this.container = document.querySelector(containerSelector);
		if (!this.container) return;
		this.buttons = this.container.querySelectorAll(titleSelector);
		this.init();
	}

	init() {
		this.buttons.forEach(btn => {
			const contentId = btn.getAttribute('aria-controls');
			const content = document.getElementById(contentId);

			if (!content) return;

			const isExpanded = btn.getAttribute('aria-expanded') === 'true';
			content.hidden = !isExpanded;

			if (!isExpanded) {
				content.classList.add('is-hidden');
				btn.classList.add('is-closed');
			} else {
				content.classList.remove('is-hidden');
				btn.classList.remove('is-closed');
			}
			btn.addEventListener('click', () => this.toggle(btn, content));
		});
	}

	toggle(btn, content) {
		const isExpanded = btn.getAttribute('aria-expanded') === 'true';
		const newState = !isExpanded;
		btn.setAttribute('aria-expanded', newState);
		content.hidden = !newState;
		btn.classList.toggle('is-closed', !newState);
		content.classList.toggle('is-hidden', !newState);
	}
}

document.addEventListener('DOMContentLoaded', () => {


	const popularSliders = document.querySelectorAll('[data-popular-products-gallery]');
	const sliderNodes = document.querySelectorAll('[data-product-grid-item-gallery]');

	sliderNodes.forEach(node => {
		new ProductCardSlider(node);
	});

	document.querySelectorAll('[data-category-item-gallery]').forEach(node => {
		new ProductCardSlider(node);
	});

	popularSliders.forEach(slider => new PopularProductsSlider(slider));

	new SidebarAccordion('[data-listing-side]', '[data-listing-side-title]');

	new CarCompatibility();

	new ProductGallery('[data-product-gallery]');

});
